const SIGNIFICANT_CHARS_RE = /[\d#]+/g //mezohosszba beleszamito karakterek
const INSIGNIFICANT_CHARS_RE = /[^\d#]/g //mezohosszba nem szamito karakterek

/**
 *
 * @param pattern
 * @return {{min, max, fakeMin: number, fakeMax: number}|{min, max, fakeMin, fakeMax}}
 */
const countCharsWithoutMask = function (pattern) {
  if (Array.isArray(pattern)) {
    const max = pattern.reduce((acc, next) => {
      if (next && acc && next.length > acc.length) {
        acc = next
      }
      return acc
    })
    const min = pattern.reduce((acc, next) => {
      if (next.length < acc.length) {
        acc = next
      }
      return acc
    })
    const fakeMin = min.replace(INSIGNIFICANT_CHARS_RE, '').length
    const fakeMax = max.replace(INSIGNIFICANT_CHARS_RE, '').length
    return { min: min.length, max: max.length, fakeMin, fakeMax }
  } else {
    const min = pattern.length
    const max = pattern.length
    let counter = 0
    pattern.match(SIGNIFICANT_CHARS_RE).forEach((match) => {
      counter += match.length
    })
    return { min, max, fakeMin: counter, fakeMax: counter }
  }
}

export default countCharsWithoutMask
